var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.7441,
    r: 41.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3511 20.6894C22.0247 17.137 27.6335 15.2612 33.4063 15.6098C39.2447 15.9584 45.1159 19.9756 52.1843 26.5658C65.1075 38.634 76.4563 43.6638 72.7007 53.8064C68.9451 63.949 49.2651 70.9543 35.8991 67.0367C22.5331 63.119 8.47827 50.8184 10.8891 35.5796C12.0207 28.4416 15.2351 23.7106 18.3511 20.6894Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.2858 32.0771C65.8997 32.0771 68.8294 29.1117 68.8294 25.4537C68.8294 21.7957 65.8997 18.8303 62.2858 18.8303C58.6719 18.8303 55.7422 21.7957 55.7422 25.4537C55.7422 29.1117 58.6719 32.0771 62.2858 32.0771Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1669 54.9851C55.1669 56.7613 53.6417 58.2221 51.8377 58.2221H31.4361C29.5665 58.2221 28.0413 56.7613 28.0413 54.9851V37.7875C28.0413 37.1899 28.5497 36.7085 29.1729 36.7085H30.3045H52.9037H54.0353C54.6585 36.7085 55.1669 37.1899 55.1669 37.7875V54.9851ZM32.5677 27.0141C32.5677 25.1881 34.0929 23.7273 35.9625 23.7273H47.2621C49.1317 23.7273 50.6569 25.1881 50.6569 27.0141V34.5505H32.5677V27.0141ZM54.0353 34.5505H52.9037V26.9975C52.9037 23.9763 50.3617 21.5527 47.2457 21.5527H35.9461C32.8301 21.5527 30.2881 23.9763 30.2881 26.9975V34.5505H29.1565C27.2869 34.5505 25.7617 36.0113 25.7617 37.7875V54.9851C25.7617 57.9565 28.3037 60.3801 31.4197 60.3801H51.8213C54.9373 60.3801 57.4137 57.9565 57.4137 54.9851V37.7875C57.4301 36.0113 55.9049 34.5505 54.0353 34.5505Z",
    fill: "#0B493F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7344 43.5479V50.2044C37.7344 51.4162 38.7184 52.3956 39.8992 52.3956H42.064C43.2612 52.3956 44.2288 51.3996 44.2288 50.2044V43.5479H37.7344ZM42.0804 50.2044H39.9156V45.7556H42.0804V50.2044Z",
    fill: "#0B493F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 42.5252,
    y1: 15.7529,
    x2: 41.5809,
    y2: 68.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#166649",
    stopOpacity: 0.333
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 55.7461,
    y1: 25.4616,
    x2: 68.8196,
    y2: 25.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4EBE2",
    stopOpacity: 0.333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrLock);
export default __webpack_public_path__ + "static/media/ubr-lock.10fdbb833f2fe2f88d19c59d9c9163b0.svg";
export { ForwardRef as ReactComponent };